// Organisation option label: name + code + country/domain; when the same name/code repeats, a short record id keeps every option distinct. Never merges records.
export const orgLabel = (o, list = []) => {
  const name = o.legal_name && o.legal_name !== o.name ? `${o.name} (${o.legal_name})` : o.name;
  const meta = [o.code, o.country, o.domain || o.email_domain].filter(Boolean);
  const twins = list.filter((x) => (x.name || "").trim().toUpperCase() === (o.name || "").trim().toUpperCase() && (x.code || "") === (o.code || "")).length;
  if (twins > 1 && o.id) meta.push(`#${String(o.id).slice(0, 6)}`);
  return meta.length ? `${name} · ${meta.join(" · ")}` : name;
};
